// noinspection ES6PreferShortImport

import { useNavigation } from '@react-navigation/native';
import {
    Linking,
    Platform
} from 'react-native';
import { useSelector } from 'react-redux';

import { LOG_TO_RELEASE } from '../../actions/logs';
import { DbLastUpdateDate } from '../../combo/DbLastUpdateDate';
import { LanguageSelector } from '../../combo/LanguageSelector';
import {
    Logo,
    NavigationItem,
    NavigationList,
    Page,
    React,
    RText,
    ScrollView,
    Section,
    Text,
    View
} from '../../common';
import { Dimensions } from '../../common/react';
import { SwipeBack } from '../../common/SwipeBack';
import {
    ALLOWED_LANGUAGES,
    DISABLE_INSTALL_MOBILE_APP_MESSAGE,
    MODE,
    VERSION as version
} from '../../config';
import { getSupportedlanguages } from '../../selectors';
import { getFormValues } from '../../selectors/forms';
import { dbGettr } from '../../selectors/utils';
import { COLORS } from '../../styles/colors';
import { isMobile } from '../../utils/strings';
import { getSupportBody } from '../../utils/supportInfo';
import { DebugButton } from '../Services/Debug/DebugScreen';
import { TestConsentsButton } from '../Services/TestConsents/TestConsentsScreen';

const style = {
    color: COLORS.STANDARD_GRAY,
    fontSize: 10,
    textAlign: 'center',
    padding: 3,
};

export const openURL = ({
    routeTo,
    blank = true,
}) => {
    const addParams = String(routeTo)
        .indexOf('mailto') === -1 ? '' : getSupportBody();
    if (Platform.OS === 'web') {
        return window.open(`${routeTo}${addParams}`, blank ? '_blank' : '_self');
    }
    return Linking.openURL(`${routeTo}${addParams}`);
};

/**
 * The 'About' page. (☆☆☆☆☆)
 * Contains an application attribution information
 * such as logo, legals, support link, version etc.
 */

export const About = Page.register(() => {
    const languages = ALLOWED_LANGUAGES?.length
        ? useSelector(getSupportedlanguages)
            ?.filter
            ?.(({ id }) => ALLOWED_LANGUAGES?.find(({ id: f }) => f === id))
        : useSelector(getSupportedlanguages);
    const GetWidth = () => {
        try {
            const {
                width,
                height,
            } = Dimensions.get('window');
            return (
                <Text
                    style={style}
                    centered
                >
                    {' '}
                    Resolution: {width?.toFixed(0)}x{height.toFixed(0)}
                </Text>
            );
        } catch {
            return null;
        }
    };

    const d = useSelector(getFormValues);

    const navigation = useNavigation();

    const onSwipeBackHandler = () => {
        navigation.navigate('Home');
    };

    const useGoogleBackup = useSelector(dbGettr('useGoogleBackup', false));
    return (
        <Page
            name="others"
            noscroll
        >
            <SwipeBack
                forOS={[ 'ios' ]}
                onSwipeBack={onSwipeBackHandler}
                enabled={true}
            >
                <ScrollView style={{ flex: 1 }}>
                    <Section>
                        <Logo.Wrapper
                            title="others.mainGoal"
                            subtitle="others.serviceSource"
                        />
                    </Section>
                    {Platform.OS === 'web' && isMobile() && !DISABLE_INSTALL_MOBILE_APP_MESSAGE && (
                        <NavigationItem
                            onItem={() => {
                                const urlKey = 'titles.otherNavigationMwaLinkFallback';
                                const defaultUrl = Object.R(urlKey);
                                try {
                                    if (!!defaultUrl && defaultUrl !== urlKey) {
                                        openURL({
                                            routeTo: defaultUrl,
                                        });
                                        return;
                                    }
                                    const docId = d?.deeplink?.docId;
                                    const utm_campaign = d?.deeplink?.utm_campaign ?? 'mma_link_from_other_section';
                                    const dId = docId ? `?docId=${docId}` : '';
                                    const domain =
                                        Object.R('titles.otherNavigationMwaLinkDomain') ?? 'https://ln.aibolit.md';
                                    const url = `${domain}/mma${dId}`;
                                    openURL({
                                        routeTo: url,
                                    });
                                    Object.trackAction('click_mobile_link_from_other', {
                                        utm_source: 'mwa',
                                        utm_medium: 'mma_link_from_other_section',
                                        utm_campaign,
                                    });
                                } catch (e) {
                                    defaultUrl !== urlKey &&
                                    !!defaultUrl &&
                                    openURL({
                                        routeTo: defaultUrl,
                                    });
                                }
                            }}
                            firstItem={true}
                            title="titles.otherNavigationMwaTitle"
                            containerStyle={{
                                borderBottomWidth: 0,
                            }}
                        />
                    )}
                    {/* {useGoogleBackup && ( */}
                    {/*     <NavigationItem */}
                    {/*         onItem={() => { */}
                    {/*             navigation.navigate('Backup'); */}
                    {/*         }} */}
                    {/*         firstItem={true} */}
                    {/*         title="titles.backupRestore" */}
                    {/*         containerStyle={{ */}
                    {/*             borderBottomWidth: 0, */}
                    {/*         }} */}
                    {/*     /> */}
                    {/* )} */}
                    {languages?.length > 1 ? <LanguageSelector firstItem={true}/> : null}
                    <NavigationList
                        dataEnum={[ 'othersNavigation' ]}
                        onItem={(item) => {
                            openURL(item);
                        }}
                        useSwipeToHome
                        filtredFields={MODE === 'uat' ? [ 'about',
                            'privacy',
                            'user_agreement',
                            'personalData' ] : []}
                    />
                    <View>
                        <Section>
                            <DbLastUpdateDate/>
                            <RText
                                centered
                                style={{
                                    fontSize: 10,
                                }}
                                id="others.version"
                                params={{
                                    version,
                                }}
                            />
                            {MODE === 'qa' || LOG_TO_RELEASE ? (
                                <View
                                    style={{
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <View
                                        style={{
                                            flexDirection: 'row',
                                        }}
                                    >
                                        <GetWidth/>
                                    </View>
                                    <DebugButton/>
                                    <TestConsentsButton/>
                                </View>
                            ) : null}
                        </Section>
                    </View>
                </ScrollView>
            </SwipeBack>
        </Page>
    );
});
